import type { ReactElement } from "react";
import { useRouteError } from "react-router";
import { PageErrorFallback } from "../components/app/ErrorBoundary";

/** Prevents React Router's default error page from becoming user-visible. */
export default function RouterErrorElement(): ReactElement {
  const error = useRouteError();
  console.error("Unhandled router error", error);
  return <PageErrorFallback />;
}
